import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 0a.5.5 0 01.5.5v2a.5.5 0 11-1 0v-2a.5.5 0 01.5-.5zM.646.646a.5.5 0 01.708 0l1.5 1.5a.5.5 0 11-.708.708l-1.5-1.5a.5.5 0 010-.708zM0 4.5A.5.5 0 01.5 4h2a.5.5 0 110 1h-2a.5.5 0 01-.5-.5zm12 6a.5.5 0 01.5-.5h2a.5.5 0 110 1h-2a.5.5 0 01-.5-.5zM10.5 12a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zm1.646.146a.5.5 0 01.707 0l1.5 1.5a.5.5 0 01-.707.707l-1.5-1.5a.5.5 0 010-.707zM7.765 3.7c.427-.427.592-.589.747-.694.676-.46 1.531-.468 2.166-.051.145.095.299.245.71.657.412.412.563.566.658.71.417.636.408 1.49-.052 2.167-.104.154-.267.32-.694.747l-.619.619a.5.5 0 00.708.707l.618-.62.043-.042c.37-.37.606-.606.772-.85.675-.993.71-2.287.06-3.277-.16-.241-.39-.472-.742-.823l-.044-.045-.045-.045c-.351-.351-.582-.582-.824-.74-.99-.651-2.283-.616-3.277.059-.243.165-.48.402-.85.771l-.042.043-.619.619a.5.5 0 10.707.707l.619-.619zM2.992 7.06l-.043.042c-.37.37-.606.606-.771.85-.676.993-.71 2.287-.06 3.277.158.241.39.472.74.824l.046.044.044.045c.351.351.582.582.824.74.99.651 2.284.616 3.278-.06.243-.164.48-.4.849-.77l.043-.043.618-.619a.5.5 0 00-.707-.707l-.619.619c-.427.427-.592.589-.746.694-.677.46-1.532.468-2.167.051-.144-.095-.299-.245-.71-.657-.412-.412-.563-.566-.657-.71-.418-.636-.409-1.49.05-2.167.106-.154.268-.32.695-.747l.619-.619a.5.5 0 10-.707-.707l-.62.62z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgLinkBreak2 = styled(BaseComponent)`
  outline: none;
`
export default SvgLinkBreak2
